import {
  Alert,
  Button,
  Grid2 as Grid,
  Stack,
  TextField,
  Typography,
  useTheme,
  useMediaQuery,
  ImageList,
  ImageListItem,
  Box,
  Modal,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { KeyboardArrowDown } from "@mui/icons-material";
import { Header } from "./Header";
import { sendForm } from "@emailjs/browser";

const serviceID = "service_2pgsypn";
const templateID = "template_ucngvji";

const Hero: React.FC = () => {
  const [showAlert, setShowAlert] = useState(false);
  const [selectedImage, setSelectedImage] = useState<string | null>(null);

  useEffect(() => {
    // when the component is mounted, the alert is displayed for 3 seconds
    setTimeout(() => {
      setShowAlert(false);
    }, 3000);
  }, []);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handleImageClick = (imageSrc: string) => {
    setSelectedImage(imageSrc);
  };

  const handleCloseModal = () => {
    setSelectedImage(null);
  };

  const galleryImages = [
    { img: '/images/IMG_7124.jpg', title: 'Cody fixing a dryer vent' },
    { img: '/images/IMG_7148.jpg', title: 'Dryer Service 1' },
    { img: '/images/IMG_7149.jpg', title: 'Dryer Service 1' },
    { img: '/images/IMG_7153.jpg', title: 'Dryer Service 1' },
    { img: '/images/IMG_8600.jpg', title: 'Dryer Service 1' },
    { img: '/images/IMG_6913.jpeg', title: 'Dryer Service 1' },
    { img: '/images/IMG_6914.jpeg', title: 'Dryer Service 2' },
    { img: '/images/IMG_6915.jpeg', title: 'Dryer Service 3' },
    { img: '/images/IMG_6918.jpeg', title: 'Dryer Service 5' },
    { img: '/images/IMG_6919.jpeg', title: 'Dryer Service 6' },
    { img: '/images/IMG_6920.png', title: 'Dryer Service 7' },
    { img: '/images/IMG_6922.png', title: 'Dryer Service 7' },

  ];

  return (
    <Grid container p={1} mb={20}>
      <Header />

      {/* <Grid size={7}>
        <Stack m={5} ml={10}>
          <Typography variant="h1" color="primary">
            Portland Dryer Mechanic
          </Typography>

          <Typography variant="h2" color="info" mt={10}>
            The friendliest dryer repair service in Portland, Oregon
          </Typography>
        </Stack>
      </Grid> */}
      <Grid
        size={12}
        display={"flex"}
        alignItems={"center"}
        justifyContent={"center"}
        mt={5}
      >
        <img
          src="logo.png"
          alt="dryer"
          style={{ width: isMobile ? "65vw" : "35vw" }}
        />
      </Grid>

      <Grid
        mt={1}
        size={12}
        display={"flex"}
        alignItems={"center"}
        justifyContent={"center"}
      >
        <Stack
          display={"flex"}
          alignItems={"center"}
          justifyContent={"center"}
          width={"80%"}
        >
          <Typography align="center" variant="h4" color="secondary">
            Scroll Down to Schedule a Service
          </Typography>
          <Typography variant="h4" color="secondary" gutterBottom>
            <KeyboardArrowDown fontSize="large" />
            <KeyboardArrowDown fontSize="large" />
            <KeyboardArrowDown fontSize="large" />
          </Typography>
        </Stack>
      </Grid>

      <Grid
        mt={10}
        size={12}
        display={"flex"}
        alignItems={"center"}
        justifyContent={"center"}
      >
        <Stack m={5} width={"75%"}>
          <Typography variant="h4" color="primary" gutterBottom>
            Schedule a Service
          </Typography>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              const formData = new FormData(e.currentTarget);
              const name = formData.get("name");
              const email = formData.get("email");
              const serviceDate = formData.get("serviceDate");
              const htmlForm: HTMLFormElement = e.currentTarget;
              console.log({ name, email, serviceDate, htmlForm });

              sendForm(serviceID, templateID, htmlForm);

              htmlForm.reset();
              setShowAlert(true);
            }}
          >
            <Stack spacing={2}>
              <TextField
                label="Name"
                name="name"
                variant="outlined"
                fullWidth
                required
              />
              <TextField
                label="Email"
                name="email"
                type="email"
                variant="outlined"
                fullWidth
                required
              />
              <TextField
                label="Phone Number"
                name="phone"
                variant="outlined"
                fullWidth
                required
              />

              <TextField
                label="Requested Service Date"
                name="serviceDate"
                type="date"
                InputLabelProps={{ shrink: true }}
                variant="outlined"
                fullWidth
                required
              />
              <TextField
                label="Message"
                name="message"
                multiline
                rows={4}
                variant="outlined"
                fullWidth
              />

              <Button type="submit" variant="contained" color="primary">
                Submit
              </Button>
              {showAlert && (
                <Alert severity="success">
                  Your request has been submitted. The Dryer Mechanic will
                  contact you shortly.
                </Alert>
              )}
            </Stack>
          </form>
        </Stack>
      </Grid>

      {/* Image Gallery Section */}
      <Grid
        mt={10}
        size={12}
        display={"flex"}
        alignItems={"center"}
        justifyContent={"center"}
        flexDirection={"column"}
      >
        <Typography variant="h4" color="primary" gutterBottom>
          Our Recent Work
        </Typography>
        <Box sx={{ width: '90%', overflowY: 'hidden' }}>
          <ImageList
            // variant="masonry"
            cols={isMobile ? 2 : 4}
            gap={8}
          >
            {galleryImages.map((item) => (
              <ImageListItem 
                key={item.img}
                sx={{ 
                  cursor: 'pointer',
                  '&:hover': {
                    opacity: 0.8,
                    transition: 'opacity 0.3s ease-in-out'
                  }
                }}
                onClick={() => handleImageClick(item.img)}
              >
                <img
                  src={item.img}
                  alt={item.title}
                  loading="lazy"
                  style={{ borderRadius: '8px' }}
                />
              </ImageListItem>
            ))}
          </ImageList>
        </Box>

        {/* Image Modal */}
        <Modal
          open={selectedImage !== null}
          onClose={handleCloseModal}
          aria-labelledby="image-modal"
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            p: 2,
          }}
        >
          <Box
            sx={{
              position: 'relative',
              maxWidth: '90vw',
              maxHeight: '90vh',
              outline: 'none',
            }}
            onClick={handleCloseModal}
          >
            {selectedImage && (
              <img
                src={selectedImage}
                alt="Selected work"
                style={{
                  maxWidth: '100%',
                  maxHeight: '90vh',
                  objectFit: 'contain',
                  borderRadius: '8px',
                  backgroundColor: 'white',
                }}
              />
            )}
          </Box>
        </Modal>
      </Grid>
    </Grid>
  );
};

export default Hero;
